// Packages
import React from "react";

// Controllers
import useControllers from "../../../../controllers";

// Components
import useComponents from "../../../components";

const UsersEdit = () => {
  const { useScreenHooks } = useControllers();
  const { useUsers } = useScreenHooks();
  const { useUsersEdit } = useUsers();
  const {
    control,
    handleSubmit,
    onSubmit,
    showModal,
    handleCloseModal,
    userData,
    error,
    activateUser,
    handleChangeActivate,
    listRoles,
    listCountries,
    groupedPermissions,
    rolePermissions,
    currentUserRole,
    loading,
  } = useUsersEdit();

  const {
    ContentWrappers,
    DatePickerFieldControlled,
    RadioButtonControlled,
    useButtons,
    TextFieldControlled,
    SelectFieldControlled,
    SelectMultiFieldControlled,
    FormLabel,
    Typography,
    useModals,
    InputSwitch,
    PermissionOverridesGroup,
  } = useComponents();

  const { DefaultButton } = useButtons();
  const { DefaultModal } = useModals();

  // Show loading state while fetching user data
  if (loading) {
    return (
      <div className="bg-white px-16 pt-10 pb-12 mx-24 rounded-lg">
        <div className="flex justify-center items-center min-h-[400px]">
          <div className="text-center">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-gray-900 mx-auto mb-4"></div>
            <p className="text-gray-600">Cargando datos del usuario...</p>
          </div>
        </div>
      </div>
    );
  }

  // Don't render form if user data not loaded
  if (!userData) {
    return null;
  }

  return (
    <div className="bg-white px-16 pt-10 pb-12 mx-24 rounded-lg">
      <form onSubmit={handleSubmit(onSubmit)}>
        <ContentWrappers
          maxCol='48%'
          repeatGrid
          gap={{
            row: "0px",
            column: "4%",
          }}
        >
          <TextFieldControlled
            type="text"
            id="abi-user-name"
            name="name"
            control={control}
            label="Nombre"
            placeholder="Nombre"
            error={error}
          />
          <TextFieldControlled
            type="text"
            id="abi-user-lastname"
            name="last_name"
            control={control}
            label="Apellido"
            placeholder="Apellido"
            error={error}
          />
        </ContentWrappers>
        <ContentWrappers
          gridColums={["48%", "15vw"]}
          gap={{
            row: "0px",
            column: "4%",
          }}
        >
          <TextFieldControlled
            type="email"
            id="abi-user-email"
            control={control}
            label="Email"
            placeholder="Email"
            name="email"
            error={error}
          />
          <div>
            <FormLabel label="Fecha de nacimiento" />
            <DatePickerFieldControlled
              name="birth_date"
              id="abi-user-date"
              control={control}
              maxDate={new Date().toString()}
            />
          </div>
        </ContentWrappers>
        <ContentWrappers
          maxCol='48%'
          repeatGrid
          gap={{
            row: "0px",
            column: "4%",
          }}
        >
          <SelectFieldControlled
            label={"Equipo ABI"}
            placeholder={"Selecciona una opción"}
            name={`abi_team`}
            id={`abi-team-abi`}
            control={control}
            options={[
              { label: "Global", value: "Global" },
            ]}
          />
          <SelectMultiFieldControlled
            label={"País"}
            placeholder={"Selecciona una opción"}
            name={`country_id`}
            id={`abi-country`}
            control={control}
            options={listCountries}
            limitTags={3}
            disabled={currentUserRole !== "Súper Administrador" && currentUserRole !== "Administrador"}
          />
        </ContentWrappers>
        <ContentWrappers
          maxCol='48%'
          repeatGrid
          gap={{
            row: "0px",
            column: "4%",
          }}
        >
          {currentUserRole === "Súper Administrador" && (
            <SelectFieldControlled
              label={"Rol"}
              placeholder={"Selecciona un rol"}
              name={`rol`}
              id={`abi-user-rol`}
              control={control}
              options={listRoles}
            />
          )}
          <div>
            <FormLabel label="Estado" />
            <InputSwitch
              id={"abi-user-active"}
              name={"active"}
              onChange={handleChangeActivate}
              label={activateUser.label}
              defaultChecked={userData?.active}
            />
          </div>
        </ContentWrappers>

        <div className="mt-8 mb-4">
          <FormLabel label="Permisos Personalizados" />
          <p className="text-xs text-neutral-500 mt-1">
            Sobrescribe permisos específicos del rol. Los permisos no marcados se heredan del rol asignado.
          </p>
        </div>
        <PermissionOverridesGroup
          groupedPermissions={groupedPermissions}
          control={control}
          name="permissions"
          rolePermissions={rolePermissions}
        />
        <div className="text-center mt-8">
          <DefaultButton color="secondary" type="submit">
            Guardar
          </DefaultButton>
        </div>
      </form>
      <DefaultModal isOpen={showModal}>
        <div className="flex items-center flex-col space-y-8">
          <Typography variant="body2">Cambios realizados con éxito</Typography>
          <DefaultButton color="success" onClick={handleCloseModal}>
            Aceptar
          </DefaultButton>
        </div>
      </DefaultModal>
    </div>
  );
};

export default UsersEdit;
